module.exports = __webpack_public_path__ + "img/vue2-semelle_rouge.6c55c4f8.png";